// extracted by mini-css-extract-plugin
export default {"label":"label---fdufp","list":"list---G6UJK","isEmptyMessage":"isEmptyMessage---UvFDR"};